<template>
  <PageHeader
    title="Belépés"
    hero-class="bg-login"
    :breadcrumb="[{name:'Belépés', url:'/belepes'}, 'Elfelejtett jelszó']"
  >
    <section
      id="login"
      @keyup.enter="login"
    >
      <div class="bg-white w-full pt-14 pb-14 text-center">
        <h1 class="font-source-serif-pro text-xl font-semibold">
          Elfelejtett jelszó
        </h1>
        <p class="text-semigray text-base mt-4">
          Add meg az e-mail címed és elküldjük a tennivalókat!
        </p>
        <ReInput
          id="email"
          v-model="form.email"
          :validation-errors="validationErrors.email"
          placeholder="E-mail"
          type="email"
          class="w-full px-4 lg:px-auto lg:w-1/3  mx-auto mt-8"
          icon="/img/mail2_icon.svg"
        />

        <div class="w-full px-4 lg:px-auto lg:w-1/3 mx-auto flex gap-6 mt-6 place-content-center">
          <button
            :disabled="isLoading"
            type="button"
            class="btn btn-red w-1/2"
            @click.prevent="submit()"
          >
            Küldés
          </button>
          <!-- <nuxt-link
            to="/regisztracio"
            class="btn btn-yellow w-full"
          >
            Regisztráció
          </nuxt-link> -->
        </div>
        <div class="w-full px-4 lg:px-auto  lg:w-1/3 mx-auto text-center mt-8">
          <nuxt-link
            to="/belepes"
            class="link link-gray"
          >
            Vissza
          </nuxt-link>
        </div>
      </div>
    </section>
  </PageHeader>
</template>
<script>
import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReInput from "~/components/rxt/reform/ReInput.vue";

export default {
  components: {
    PageHeader,
    ReInput
  },
  data() {
    return {
      form: {
        email: ""
      },
      validationErrors: {},
      isLoading: false
    };
  },
  methods: {
    submit() {
      this.isLoading = true;
      this.$axios
        .$post("/password_resets", this.form)
        .then(response => {
          this.$rxt.toast(
            "Sikeres e-mail küldés, kérlek ellenőrizd az e-mail fiókodat!",
            {
              title: "Sikeres művelet",
              autoHideDelay: 10000,
              variant: "success"
            }
          );
          this.$router.push("/belepes");
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;

          if (error.response.status === 422) {
            this.validationErrors = error.response.data.details;

            this.$rxt.toast(
              "Javítsd az űrlapon a piros magyarázószöveggel megjelölt hibát!",
              {
                title: "Sikertelen művelet",
                autoHideDelay: 3500,
                variant: "danger"
              }
            );
          } else {
            this.$rxt.toast(
              "Szerver hiba, kérlek keresd fel az oldal üzemeltetőit!",
              {
                title: "Sikertelen művelet",
                autoHideDelay: 3500,
                variant: "danger"
              }
            );
          }
        });
    }
  }
};
</script>
